import styled, {withTheme} from 'styled-components';
import LogoSVG from '../../assets/images/logo-lg.svg';

const LogoLarge = styled.span`
  background: url(${LogoSVG}) no-repeat right center;
  background-size: 273px 65px;
  display: block;
  height: 65px;
  width: 273px;
`;

export default withTheme(LogoLarge);
